module.exports = __webpack_public_path__ + "static/8-42cbbe50721c08720cf9a782f9178e06.jpg";